var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`role ${_vm.role}`,on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.roles[_vm.role]))])
}
var staticRenderFns = []

export { render, staticRenderFns }